import type { NotifyPort } from '@/features/messages/domain/notify'
import type { PermissionConfiguration, PermissionPort } from '../domain/permission'

const getPermissionConfig = async (port: PermissionPort, notify: NotifyPort): Promise<PermissionConfiguration | null> => {
	try {
		return await port.getConfig()
	} catch {
		notify.error('permission.configLoadFailed')
		return null
	}
}

export { getPermissionConfig }
